import env from "utils/helpers/functions/env";

const currencyCode =
    env('REACT_APP_CURRENCY_CODE') ||
    env('REACT_APP_CURRENCT_CODE') ||
    'UAH';

const conf = { 
    siteUrl     : env('REACT_APP_PUBLICSITE'),   
    apiAdmin    : env('REACT_APP_APIURL'),       
    dataServer  : env('REACT_APP_DATA'),         
    googleId    : env('REACT_APP_GOOGLE_ID'),
    googleRedirectUri : env('REACT_APP_GOOGLE_REDIRECT_URI'),
    domainUuid : env('REACT_APP_DOMAIN_UUID'),
    defOptimizioWidth : 1500,
    saasMode    : env('REACT_APP_SAAS_MODE') === 'true',
    usdRate : Number(env('REACT_APP_USD_RATE')) || 0,
    currencyCode,
    currencyName: env('REACT_APP_CURRENCY_NAME') || '',
    currencySymbol: env('REACT_APP_CURRENCY_SYMBOL') || '₴',
    currencyOnce: env('REACT_APP_CURRENCY_ONCE') === 'true',
    euroMode: env('REACT_APP_EURO_MODE') === 'true',
    /** @deprecated use currencyCode; kept for tariffs fallback */
    currentCode : currencyCode,
    masterUrl   : env('REACT_APP_MASTER_URL'),
    tariffTelegram : env('REACT_APP_TARIFF_TELEGRAM') || '@e_landing',
    defLofin    : env('REACT_APP_DEF_LOGIN'),
    defPass     : env('REACT_APP_DEF_PASS'),
    tinyMode    : env('REACT_APP_TINY_MODE') === 'true',
    cloudflareMode: env('REACT_APP_CLOUDFLARE_MODE') === 'true',
    vat: Number(env('REACT_APP_VAT')) || 20,
} 

export default conf; 